import {LHRFullPageScreenshot} from "../types";

interface LHRScreenshotProps {
  fullPageScreenshot: LHRFullPageScreenshot;
  audits: unknown;
}
export const LHRScreenshot = ({audits, fullPageScreenshot}: LHRScreenshotProps) => {
  // @ts-expect-error legacy
  const auditFinalScreenshot = audits["final-screenshot"];
  // @ts-expect-error legacy
  const auditFPScreenshot = audits["full-page-screenshot"];

  if (auditFinalScreenshot && auditFinalScreenshot.details) {
    return (
      <div key="screenshot" className="pagespeed-screenshot">
        <img alt="final screenshot" className="img-fluid" src={auditFinalScreenshot.details.data} />
      </div>
    );
  } else if (fullPageScreenshot && fullPageScreenshot.screenshot) {
    return (
      <div key="screenshot" className="pagespeed-screenshot">
        <img alt="screenshot" className="img-fluid" src={fullPageScreenshot.screenshot.data} />
      </div>
    );
  } else if (auditFPScreenshot && auditFPScreenshot.details) {
    // deprecated: only used for old reports, delete branch after 2024-01-01
    return (
      <div key="screenshot" className="pagespeed-screenshot">
        <img alt="full page screenshot" className="img-fluid" src={auditFPScreenshot.details.screenshot.data} />
      </div>
    );
  }
  return null;
};
